import React, { useState, useEffect } from 'react';
import ChangePassword from './ChangePassword';

const btn = {padding:'8px 16px',borderRadius:'6px',border:'none',cursor:'pointer',fontWeight:'500',fontSize:'14px'};
const inp = {width:'100%',padding:'8px 12px',border:'1px solid #e2e8f0',borderRadius:'6px',fontSize:'14px',boxSizing:'border-box',marginBottom:'10px'};

const DOC_LABELS = {aadhaar:'Aadhaar',pan:'PAN Card',photo:'Photo',bank_passbook:'Bank Passbook',salary_slip_it:'Salary Slip / IT Return',other:'Other Document',chit_document:'Chit Document',lic_assignment:'LIC Assignment',property_document:'Property Document'};

export default function Manager1Dashboard({ user, onLogout }) {
  const [tab, setTab] = useState('cases');
  const [caseTab, setCaseTab] = useState('pending');
  const [caseSearch, setCaseSearch] = useState('');
  const m1MatchSearch = c => { const q = caseSearch.trim().toLowerCase(); if (!q) return true; return [c.case_number, c.subscriber_name, c.subscriber_mobile, c.group_code, c.ticket_no].some(v => (v == null ? '' : String(v)).toLowerCase().includes(q)); };
  const m1FmtDate = d => d ? new Date(d).toLocaleDateString('en-IN', {timeZone:'Asia/Kolkata', day:'2-digit', month:'short', year:'numeric'}) : '';
  const [m1ForwardNote, setM1ForwardNote] = useState('');
  const [showRejectAll, setShowRejectAll] = useState(false);
  const [rejectAllReason, setRejectAllReason] = useState('');
  const [rejectingAll, setRejectingAll] = useState(false);
  const [cases, setCases] = useState([]);
  const [sel, setSel] = useState(null);
  const [caseNotes, setCaseNotes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [docComments, setDocComments] = useState({});
  const [msg, setMsg] = useState('');
  const [showChangePw, setShowChangePw] = useState(false);

  const getHeaders = () => ({'Content-Type':'application/json','Authorization':`Bearer ${localStorage.getItem('token')}`});

  const fetchCases = async () => {
    const r = await fetch('/api/cases', {headers:getHeaders()});
    const d = await r.json();
    setCases(d.cases || []);
  };

  const fetchDetails = async (c) => {
    const [cr, dr, nr] = await Promise.all([
      fetch(`/api/customers/${c.id}`, {headers:getHeaders()}),
      fetch(`/api/documents/${c.id}`, {headers:getHeaders()}),
      fetch(`/api/cases/${c.id}/notes`, {headers:getHeaders()})
    ]);
    const cd = await cr.json();
    const dd = await dr.json();
    const nd = await nr.json();
    setCustomers(cd.customers || []);
    setDocuments(dd.documents || []);
    setCaseNotes(nd.notes || []);
  };

  useEffect(() => { fetchCases(); }, []);

  const openCase = (c) => { setSel(c); fetchDetails(c); setTab('detail'); };

  const approveDoc = async (docId, action) => {
    const r = await fetch(`/api/documents/approve/${docId}`, {
      method:'POST', headers:getHeaders(),
      body: JSON.stringify({action, comments: docComments[docId]||''})
    });
    const d = await r.json();
    setMsg(d.message || 'Done');
    fetchDetails(sel);
  };
  const rejectAllDocs = async () => {
    if (!rejectAllReason.trim()) { setMsg('Reason is mandatory when rejecting all documents'); return; }
    setRejectingAll(true);
    try {
      const r = await fetch('/api/documents/bulk-action', {
        method:'POST', headers:getHeaders(),
        body: JSON.stringify({ document_ids: documents.map(d=>d.id), action:'rejected', comments: rejectAllReason.trim() })
      });
      const d = await r.json();
      if (d.success) {
        setMsg('Case sent back to Employee for full correction');
        setShowRejectAll(false);
        setRejectAllReason('');
        setTab('cases');
        fetchCases();
      } else setMsg(d.message || 'Error');
    } catch { setMsg('Network error'); }
    finally { setRejectingAll(false); }
  };


  const forwardToManager2 = async () => {
    const r = await fetch(`/api/documents/${sel.id}/forward`, {
      method:'POST', headers:{...getHeaders(),'Content-Type':'application/json'},
      body: JSON.stringify({notes: m1ForwardNote||''})
    });
    const d = await r.json();
    setMsg(d.message || 'Forwarded to Manager 2');
    setM1ForwardNote('');
    setTab('cases');
    fetchCases();
  };

  const sc = (s) => ({
    case_created:'#3182ce', director_approved:'#3182ce',
    doc_under_review:'#d69e2e', sent_back_for_correction:'#e53e3e',
    additional_docs_required:'#e53e3e', m1_reviewed:'#744210',
    m2_reviewed:'#553c9a', d1_doc_approved:'#553c9a',
    both_dirs_approved:'#276749', payment_scheduled:'#276749', paid:'#38a169'
  }[s]||'#718096');
  const statusLabel = (s) => ({
    case_created:'Case Created', director_approved:'Director Approved',
    doc_under_review:'Docs Under Review', sent_back_for_correction:'Sent Back',
    additional_docs_required:'More Docs Required', m1_reviewed:'Forwarded to M2',
    m2_reviewed:'With Director', d1_doc_approved:'Dir1 Approved',
    both_dirs_approved:'Both Dirs Approved', payment_scheduled:'Payment Scheduled', paid:'Paid'
  }[s]||s);

  const statusColor = (s) => ({
    pending:'#718096', uploaded:'#3182ce',
    m1_approved:'#38a169', m1_rejected:'#e53e3e', m1_resubmit:'#dd6b20',
    m2_approved:'#2f855a', d1_approved:'#1a365d', d2_approved:'#1a365d'
  }[s]||'#718096');

  const canApprove = (s) => !['m1_approved','m2_approved','d1_approved','d2_approved'].includes(s);
  const getDocsByCustomer = (customerId) => documents.filter(d => d.customer_id === customerId);

  return (
    <div style={{minHeight:'100vh',background:'#f7fafc'}}>
      <div style={{background:'#2d6a4f',color:'white',padding:'0 24px',display:'flex',alignItems:'center',justifyContent:'space-between',height:'60px'}}>
        <h1 style={{margin:0,fontSize:'20px',fontWeight:'bold'}}>AH Chits — Manager 1</h1>
        <div style={{display:'flex',alignItems:'center',gap:'16px'}}>
          <span style={{fontSize:'14px',opacity:0.8}}>{user.name||user.mobile}</span>
          <button onClick={()=>setShowChangePw(true)} style={{...btn,background:'rgba(255,255,255,0.2)',color:'white',padding:'6px 14px'}}>🔒 Change Password</button>
          <button onClick={onLogout} style={{...btn,background:'rgba(255,255,255,0.2)',color:'white',padding:'6px 14px'}}>Logout</button>
        </div>
      </div>

      <div style={{padding:'24px',maxWidth:'1100px',margin:'0 auto'}}>
        {msg && <div style={{background:'#f0fff4',color:'#276749',padding:'10px 16px',borderRadius:'8px',marginBottom:'16px',border:'1px solid #9ae6b4'}}>{msg} <button onClick={()=>setMsg('')} style={{float:'right',background:'none',border:'none',cursor:'pointer'}}>''</button></div>}

        {tab === 'cases' && (
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <h2 style={{margin:0,color:'#1a365d'}}>Cases for Document Review</h2><input value={caseSearch} onChange={e=>setCaseSearch(e.target.value)} placeholder="Search case no, name, mobile, group, ticket" style={{flex:1,maxWidth:'380px',margin:'0 16px',padding:'8px 12px',border:'1px solid #cbd5e0',borderRadius:'6px',fontSize:'13px'}} />
              <div style={{display:'flex',gap:'4px',background:'#fff',padding:'4px',borderRadius:'8px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)'}}>
                <button onClick={()=>setCaseTab('pending')} style={{padding:'6px 16px',borderRadius:'6px',border:'none',background:caseTab==='pending'?'#1d4ed8':'transparent',color:caseTab==='pending'?'#fff':'#6b7280',cursor:'pointer',fontWeight:'600',fontSize:'13px'}}>Pending ({cases.filter(c=>c.status!=='paid').length})</button>
                <button onClick={()=>setCaseTab('paid')} style={{padding:'6px 16px',borderRadius:'6px',border:'none',background:caseTab==='paid'?'#16a34a':'transparent',color:caseTab==='paid'?'#fff':'#6b7280',cursor:'pointer',fontWeight:'600',fontSize:'13px'}}>Paid ({cases.filter(c=>c.status==='paid').length})</button>
              </div>
            </div>
            <div style={{background:'white',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',overflow:'hidden'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead><tr style={{background:'#edf2f7'}}>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Case No</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Subscriber</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Prize Amount</th><th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>{caseTab==='paid'?'Paid Date':'Scheduled Date'}</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Status</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Action</th>
                </tr></thead>
                <tbody>
                  {cases.filter(c=>caseTab==='paid'?c.status==='paid':c.status!=='paid').filter(m1MatchSearch).map((c,i)=>(
                    <tr key={c.id} style={{borderTop:'1px solid #e2e8f0',background:i%2===0?'white':'#f7fafc'}}>
                      <td style={{padding:'12px 16px',fontWeight:'600',color:'#2b6cb0'}}>{c.case_number}{c.pending_review_count>0&&<div style={{marginTop:'3px'}}><span style={{background:'#fefcbf',color:'#92400e',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'700'}}>📋 {c.pending_review_count} pending review</span></div>}{c.needs_attention_count>0&&<div style={{marginTop:'3px'}}><span style={{background:'#fed7d7',color:'#c53030',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'700'}}>⚠️ {c.needs_attention_count} need attention</span></div>}</td>
                      <td style={{padding:'12px 16px'}}>{c.subscriber_name||''}</td>
                      <td style={{padding:'12px 16px'}}>₹{Number(c.prize_amount||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})}</td><td style={{padding:'12px 16px'}}>{m1FmtDate(caseTab==='paid'?c.paid_date:c.scheduled_date)}</td>
                      <td style={{padding:'12px 16px'}}><span style={{background:sc(c.status)+'20',color:sc(c.status),padding:'2px 8px',borderRadius:'12px',fontSize:'12px',fontWeight:'600'}}>{statusLabel(c.status)}</span></td>
                      <td style={{padding:'12px 16px'}}><button onClick={()=>openCase(c)} style={{...btn,background:['m1_reviewed','m2_reviewed','d1_doc_approved','both_dirs_approved','payment_scheduled','paid'].includes(c.status)?'#ebf8ff':'#e6fffa',color:['m1_reviewed','m2_reviewed','d1_doc_approved','both_dirs_approved','payment_scheduled','paid'].includes(c.status)?'#2b6cb0':'#2d6a4f',padding:'4px 12px',fontSize:'12px'}}>{['m1_reviewed','m2_reviewed','d1_doc_approved','both_dirs_approved','payment_scheduled','paid'].includes(c.status)?'View':'Review Docs'}</button></td>
                    </tr>
                  ))}
                  {cases.filter(c=>caseTab==='paid'?c.status==='paid':c.status!=='paid').filter(m1MatchSearch).length===0 && <tr><td colSpan="6" style={{padding:'24px',textAlign:'center',color:'#a0aec0'}}>No cases found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tab === 'detail' && sel && (
          <div>
            <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'20px'}}>
              <button onClick={()=>setTab('cases')} style={{...btn,background:'#e2e8f0',color:'#4a5568'}}>← Back</button>
              <h2 style={{margin:0,color:'#1a365d'}}>Case: {sel.case_number}</h2>
              <span style={{background:sc(sel.status)+'20',color:sc(sel.status),padding:'4px 12px',borderRadius:'12px',fontSize:'13px',fontWeight:'600'}}>{statusLabel(sel.status)}</span>
            </div>

            <div style={{background:'white',padding:'20px',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'16px'}}>
              <div style={{fontWeight:'700',color:'#1a365d',fontSize:'14px',marginBottom:'14px',borderBottom:'2px solid #e2e8f0',paddingBottom:'8px'}}>📋 Auction & Chit Details</div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'14px',marginBottom:'14px'}}>
                {[
                  ['Subscriber',sel.subscriber_name],
                  ['Mobile',sel.subscriber_mobile||'–'],
                  ['Group Code',sel.group_code||'–'],
                  ['Ticket No',sel.ticket_no||'–'],
                  ['Office',sel.office_name||'–'],
                  ['Auction Date',sel.auction_date?new Date(sel.auction_date).toLocaleDateString('en-IN', {timeZone:'Asia/Kolkata'}):'–'],
                  ['Chit Value','₹'+Number(sel.chit_value||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                  ['Total Months',sel.months||'–'],
                  ['Auction No',sel.auction_no||'–'],
                  ['Bid Amount','₹'+Number(sel.bid_amount||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                  ['Prize Amount','₹'+Number(sel.prize_amount||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                  ['Future Liability','₹'+Number(sel.future_liability||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                ].map(([l,v])=>(
                  <div key={l} style={{background:'#f7fafc',padding:'10px 12px',borderRadius:'6px',border:'1px solid #e2e8f0'}}>
                    <div style={{fontSize:'11px',color:'#718096',marginBottom:'3px'}}>{l}</div>
                    <div style={{fontWeight:'700',color:'#2d3748',fontSize:'14px'}}>{v}</div>
                  </div>
                ))}
              </div>
              {(sel.other_deduction>0||sel.other_deduction_reason)&&(
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'14px',borderTop:'1px solid #e2e8f0',paddingTop:'14px'}}>
                  {[
                    ['Other Deduction','₹'+Number(sel.other_deduction||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                    ['Deduction Reason',sel.other_deduction_reason||'–'],
                    ['Net Payable',sel.net_payable?'₹'+Number(sel.net_payable).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'}):'Pending'],
                  ].map(([l,v])=>(
                    <div key={l} style={{background:'#fffbeb',padding:'10px 12px',borderRadius:'6px',border:'1px solid #fcd34d'}}>
                      <div style={{fontSize:'11px',color:'#92400e',marginBottom:'3px'}}>{l}</div>
                      <div style={{fontWeight:'700',color:'#1c1917',fontSize:'14px'}}>{v}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Customer Details Section */}
            {customers.length > 0 && (
              <div style={{background:'white',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'16px',overflow:'hidden'}}>
                <div style={{background:'#2c5282',color:'white',padding:'12px 20px',fontWeight:'700',fontSize:'14px'}}>👥 Subscriber & Surety Details</div>
                <div style={{padding:'16px 20px'}}>
                  {customers.map(cu=>(
                    <div key={cu.id} style={{borderBottom:'1px solid #f0f0f0',paddingBottom:'14px',marginBottom:'14px'}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'8px'}}>
                        <div style={{fontWeight:'700',color:'#2d3748',fontSize:'14px'}}>{cu.type==='subscriber'?'👤':'🧑'} {cu.full_name} <span style={{fontSize:'12px',color:'#718096',fontWeight:'400'}}>({cu.type}{cu.surety_type?` — ${cu.surety_type}`:''})</span></div>
                        <span style={{fontSize:'13px',color:'#718096'}}>{cu.mobile}</span>
                      </div>
                      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'6px',fontSize:'13px',marginBottom:'6px'}}>
                        <div><span style={{color:'#718096'}}>Aadhaar: </span>{cu.aadhaar_number||'–'}</div>
                        <div><span style={{color:'#718096'}}>PAN: </span>{cu.pan_number||'–'}</div>
                        <div><span style={{color:'#718096'}}>Employment: </span>{cu.employment_type||'–'}</div>
                      </div>
                      {(cu.res_address||cu.office_address||cu.perm_address)&&(
                        <div style={{fontSize:'13px',borderTop:'1px solid #f0f0f0',paddingTop:'6px',marginTop:'4px'}}>
                          {[['res','Res',cu.res_address,cu.res_location_url],['office','Office',cu.office_address,cu.office_location_url],['perm','Perm',cu.perm_address,cu.perm_location_url]].map(([key,label,addr,mapUrl])=>addr?(
                            <div key={key} style={{display:'flex',alignItems:'flex-start',gap:'10px',marginBottom:'6px'}}>
                              <div style={{flex:1}}>
                                <span style={{color:'#718096'}}>{label}: </span>{addr}
                                {mapUrl&&<a href={mapUrl} target='_blank' rel='noreferrer' style={{color:'#3182ce',marginLeft:'6px'}}>📍 Map</a>}
                              </div>
                              {documents.filter(d=>d.customer_id===cu.id&&d.doc_type===(key==='res'?'res_photo':key==='office'?'office_photo':'perm_photo')).slice(-1).map(img=>(
                                <a key={img.id} href={`/api/documents/file/${img.id}?token=${localStorage.getItem('token')}`} target='_blank' rel='noreferrer'>
                                  <img src={`/api/documents/file/${img.id}?token=${localStorage.getItem('token')}`} alt={label+' location'} style={{width:'80px',height:'60px',objectFit:'cover',borderRadius:'6px',border:'1px solid #e2e8f0'}} />
                                </a>
                              ))}
                            </div>
                          ):null)}
                        </div>
                      )}
                      {cu.notes&&<div style={{marginTop:'6px',fontSize:'13px',background:'#fffff0',padding:'5px 10px',borderRadius:'6px',color:'#744210'}}>📝 {cu.notes}</div>}
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Approval Notes */}
            {caseNotes.length > 0 && (
              <div style={{background:'#fffbeb',border:'1px solid #fcd34d',borderRadius:'8px',padding:'14px 18px',marginBottom:'16px'}}>
                <div style={{fontWeight:'700',color:'#92400e',marginBottom:'10px',fontSize:'14px'}}>📋 Approval Notes</div>
                {caseNotes.map((n,i)=>(
                  <div key={i} style={{borderLeft:'3px solid #fcd34d',paddingLeft:'10px',marginBottom:'8px'}}>
                    <div style={{fontSize:'12px',color:'#718096',marginBottom:'2px'}}>
                      <strong>{n.approver_name}</strong> ({n.approver_role}) — {n.action} — {new Date(n.actioned_at).toLocaleDateString('en-IN', {timeZone:'Asia/Kolkata'})}
                    </div>
                    <div style={{fontSize:'13px',color:'#2d3748'}}>{n.comments}</div>
                  </div>
                ))}
              </div>
            )}

            {documents.length === 0 ? (
              <div style={{background:'white',padding:'40px',borderRadius:'8px',textAlign:'center',color:'#a0aec0'}}>No documents uploaded yet</div>
            ) : (
              customers.map(cu => {
                const cuDocs = getDocsByCustomer(cu.id);
                if (cuDocs.length === 0) return null;
                const approved = cuDocs.filter(d=>d.status==='m1_approved').length;
                return (
                  <div key={cu.id} style={{background:'white',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'16px',overflow:'hidden'}}>
                    <div style={{background:'#2d6a4f',color:'white',padding:'12px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                      <div>
                        <span style={{fontWeight:'700',fontSize:'15px'}}>{cu.full_name}</span>
                        <span style={{background:'rgba(255,255,255,0.2)',padding:'2px 10px',borderRadius:'12px',fontSize:'12px',marginLeft:'10px'}}>{cu.type}</span>
                      </div>
                      <span style={{fontSize:'13px',opacity:0.9}}>{approved}/{cuDocs.length} approved</span>
                    </div>
                    <div>
                      {cuDocs.map((d,i) => (
                        <div key={d.id} style={{padding:'14px 20px',borderBottom:'1px solid #f0f0f0',background:i%2===0?'white':'#fafafa',display:'flex',alignItems:'center',gap:'12px',flexWrap:'wrap'}}>
                          <div style={{flex:'1',minWidth:'180px'}}>
                            <div style={{fontWeight:'600',color:'#2d3748',fontSize:'14px'}}>{DOC_LABELS[d.doc_type]||d.doc_type}</div>
                            <div style={{fontSize:'12px',color:'#718096',marginTop:'2px'}}>{d.file_name||''}</div>
                          </div>
                          <span style={{background:statusColor(d.status)+'20',color:statusColor(d.status),padding:'3px 10px',borderRadius:'12px',fontSize:'12px',fontWeight:'600',minWidth:'90px',textAlign:'center'}}>{d.status||'pending'}</span>
                          <a href={`/api/documents/file/${d.id}?token=${localStorage.getItem('token')}`} target="_blank" rel="noreferrer" style={{...btn,background:'#ebf8ff',color:'#2b6cb0',padding:'5px 12px',fontSize:'12px',textDecoration:'none'}}>👁 View</a>
                          {canApprove(d.status) && (
                            <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                              <input placeholder="Comments (optional)" value={docComments[d.id]||''} onChange={e=>setDocComments({...docComments,[d.id]:e.target.value})} style={{padding:'5px 8px',border:'1px solid #e2e8f0',borderRadius:'4px',fontSize:'12px',width:'160px'}} />
                              <button onClick={()=>approveDoc(d.id,'approved')} style={{...btn,background:'#c6f6d5',color:'#276749',padding:'5px 10px',fontSize:'12px'}}>✓ Approve</button>
                              <button onClick={()=>approveDoc(d.id,'rejected')} style={{...btn,background:'#fed7d7',color:'#c53030',padding:'5px 10px',fontSize:'12px'}}>✗ Reject</button>
                              <button onClick={()=>approveDoc(d.id,'resubmit_requested')} style={{...btn,background:'#fefcbf',color:'#744210',padding:'5px 10px',fontSize:'12px'}}>↩ Resubmit</button>
                            </div>
                          )}
                          {!canApprove(d.status) && <span style={{fontSize:'12px',color:'#276749'}}>🔒 Locked</span>}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })
            )}
            {documents.length > 0 && (() => {
              const allApproved = documents.every(d => ['m1_approved','m2_approved','d1_approved','d2_approved','d1_rejected','d2_rejected'].includes(d.status));
              const alreadyForwarded = ['m1_reviewed','m2_reviewed','d1_doc_approved','both_dirs_approved','payment_scheduled','paid'].includes(sel.status);
              return (
                <div style={{marginTop:'20px'}}>
                  {!alreadyForwarded && (
                    <div style={{marginBottom:'12px'}}>
                      <label style={{fontSize:'12px',color:'#374151',fontWeight:'600',display:'block',marginBottom:'6px'}}>Notes for Manager 2 (mandatory) *</label>
                      <textarea value={m1ForwardNote||''} onChange={e=>setM1ForwardNote(e.target.value)} placeholder="Explain what was reviewed and any observations before forwarding..." style={{width:'100%',padding:'8px',border:'1px solid #e2e8f0',borderRadius:'6px',fontSize:'13px',height:'70px',resize:'vertical',boxSizing:'border-box'}} />
                      {!m1ForwardNote.trim() && <div style={{fontSize:'11px',color:'#e53e3e',marginTop:'4px'}}>Notes are required before forwarding to Manager 2</div>}
                    </div>
                  )}
                  {!alreadyForwarded && showRejectAll && (
                    <div style={{marginBottom:'12px',background:'#fff5f5',border:'1px solid #fed7d7',borderRadius:'8px',padding:'12px'}}>
                      <label style={{fontSize:'12px',color:'#c53030',fontWeight:'700',display:'block',marginBottom:'6px'}}>Reason for sending back (mandatory) *</label>
                      <textarea value={rejectAllReason} onChange={e=>setRejectAllReason(e.target.value)} placeholder="Explain why the case is being sent back for full correction..." style={{width:'100%',padding:'8px',border:'1px solid #fed7d7',borderRadius:'6px',fontSize:'13px',height:'60px',resize:'vertical',boxSizing:'border-box',marginBottom:'8px'}} />
                      <div style={{display:'flex',gap:'8px'}}>
                        <button onClick={rejectAllDocs} disabled={rejectingAll} style={{...btn,background:'#c53030',color:'white',fontSize:'13px'}}>{rejectingAll?'Sending...':'Confirm Send Back'}</button>
                        <button onClick={()=>{setShowRejectAll(false);setRejectAllReason('');}} style={{...btn,background:'#e2e8f0',color:'#4a5568',fontSize:'13px'}}>Cancel</button>
                      </div>
                    </div>
                  )}
                  <div style={{textAlign:'right',display:'flex',justifyContent:'flex-end',gap:'8px'}}>
                  {alreadyForwarded ? (
                    <div style={{background:'#f0fff4',border:'1px solid #9ae6b4',borderRadius:'8px',padding:'10px 16px',color:'#276749',fontSize:'13px',fontWeight:'600',display:'inline-block'}}>
                      ✅ Forwarded to Manager 2
                    </div>
                  ) : (
                    <>
                      {!showRejectAll && <button onClick={()=>setShowRejectAll(true)} style={{...btn,background:'#fff',color:'#c53030',border:'1px solid #fed7d7',fontSize:'13px'}}>↩ Reject All / Send Back</button>}
                      {!allApproved ? (
                        <div style={{background:'#fff5f5',border:'1px solid #fed7d7',borderRadius:'8px',padding:'10px 16px',color:'#c53030',fontSize:'13px',fontWeight:'600',display:'inline-block'}}>
                          ⚠️ Approve all documents before forwarding
                        </div>
                      ) : (
                        <button onClick={forwardToManager2} disabled={!m1ForwardNote.trim()} style={{...btn,background:m1ForwardNote.trim()?'#2d6a4f':'#a0aec0',color:'white',fontSize:'14px',padding:'10px 24px',cursor:m1ForwardNote.trim()?'pointer':'not-allowed'}}>Forward to Manager 2</button>
                      )}
                    </>
                  )}
                  </div>
                </div>
              );
            })()}
          </div>
        )}
      </div>
      {showChangePw && (
        <ChangePassword token={localStorage.getItem('token')} onClose={() => setShowChangePw(false)} />
      )}
    </div>
  );
}